export enum AttachmentAudience {
  All = 1,
  InvestorOnly = 2,
}
